module.exports = __webpack_public_path__ + "img/marker_four_yellow1.4af77a23.png";